import React from "react"

const ChatItemSkeleton = () => (
  <div className="flex items-start gap-3 px-3 py-3 border-b border-slate-100 animate-pulse">
    <div className="flex-1 min-w-0 space-y-2">
      <div className="flex items-center gap-1.5">
        <div className="h-5 w-12 rounded bg-slate-200" />
        <div className="h-5 w-20 rounded bg-slate-200" />
        <div className="h-5 w-16 rounded bg-slate-200 ml-auto" />
      </div>
      <div className="h-3.5 w-3/4 rounded bg-slate-100" />
    </div>
  </div>
)

const ChatListSkeleton = () => {
  return (
    <>
      {Array.from({ length: 7 }).map((_, i) => (
        <ChatItemSkeleton key={i} />
      ))}
    </>
  )
}

export default ChatListSkeleton
